import { ethers } from "ethers";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import "./styles.css";
import { serializeError } from "eth-rpc-errors";
import metamask_logo from "../../assets/images/metamask_logo.svg";
import { XCircle } from "lucide-react";
import useAddressHook from "../../hook/useAddressHook";
import useCustomFormHook from "../../hook/useCustomFormHook";
import { useDispatch } from "react-redux";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Checkbox } from "../../components/ui/checkbox";
import { Separator } from "../../components/ui/separator";
import Stripe from "../../components/section/stripe/Payment";
import { useSelector } from "react-redux";
import { useModal } from "../../utils/ModalContext";
import Price from "../price/price";
import {
  AccountsMetamask,
  connectWallet,
  isAccountConnected,
  isWalletConnected,
} from "../../lib/metamaskhandler";
import { checkout } from "./../../utils/redux/slices/checkoutSlice";
import ERC20_ABI from "../../abi/ERC20.json";
import CandyMachine_ABI from "../../abi/CandyMachine_v2.json";
import LANDREGISTRY_ABI from "../../abi/LANDRegistry.json";
import {
  CANDY_MACHINE,
  PRICE,
  USDC_REGISTRY,
  USDT_REGISTRY,
  USDT_TOKEN_INDEX,
  USDC_TOKEN_INDEX,
  MIN_GAS_LIMIT,
  MAX_GAS_LIMIT,
  SURPLUS,
  LAND_REGISTRY,
} from "../../utils/constants";
import { getTokenId } from "../../lib/utils";
import PopupLoader from "../../components/section/popupLoader";
import PayPal from "../../components/section/paypal/Paypal";
import LogoPaypal from "../../assets/images/PayPal.svg";
import ApplePay from "../../components/section/applepay/Payment";
import CheckoutModal from "../modal/checkoutModal/checkoutModal";
import {
  couponCheckWallet,
  verifyCheckout,
  controllCheckout,
} from "../../utils/redux/slices/checkoutSlice";
import NetworkModal from "../modal/networkModal/NetworkModal";
import { getChainId, onChainChange } from "../../lib/metamaskhandler";

const FormCheckout = ({
  selectedPayment,
  setSuccessPayment,
  price,
  selectedLand,
  setPayment,
  setError,
  coupon,
  activeForm,
  setActiveForm,
}) => {
  const [typeUser, setTypeUser] = useState("private");
  const {
    countryOption,
    cityOption,
    provinceOption,
    onSelectCountry,
    onSelectProvince,
  } = useAddressHook();
  const {
    register,
    handleSubmit,
    errors,
    isValid,
    referrer,
    setHookTypeUser,
    formData,
    setCountryRef,
  } = useCustomFormHook();
  const {
    openCheckoutModalHandle,
    checkoutModalVisibility,
    networkModalVisibility,
    network,
    setNetwork,
    setNetworkModalVisibility,
  } = useModal();
  const [address, setAddress] = useState("");
  const [connected, setConnected] = useState(false);
  const [inputValue, setInputValue] = useState("1");
  const [logs, setLogs] = useState({});
  const [isStripe, setIsStripe] = useState(false);
  const [isPaypal, setIsPaypal] = useState(false);
  const [freePayment, setFreePayment] = useState(false);
  const [newCountry, setNewCountry] = useState();
  const [newCity, setNewCity] = useState();
  const [newProvince, setNewProvince] = useState();
  const [countryName, setCountryName] = useState();
  const [cityName, setCityName] = useState();
  const [user, setUser] = useState();
  const [couponApply, setCouponApply] = useState("");
  const [paymentInfo, setPaymentInfo] = useState();
  const [startCall, setStartCall] = useState(false);
  const [tokenIds, setTokenIds] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [controllPriceBE, setControllPriceBE] = useState(0);
  const [typeCreditCard, setTypeCreditCard] = useState("");
  const [specialCountry, setSpecialCountry] = useState(null);
  const [activePaymentButton, setActivePaymentButton] = useState(true);
  const apiResponse = useSelector((state) => state?.checkout?.apiResponse);
  const couponValidate = useSelector((state) => state?.checkout?.coupon);
  const checkoutLands = useSelector(
    (state) => state?.checkout?.controllCheckout
  );
  const useractual = useSelector((state) => state?.user?.user?.data);
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const verifyImportBe = useSelector(
    (state) => state?.checkout?.verifyCheckout
  );

  const userAddress = useSelector((state) => state?.user?.walletAddress);

  useEffect(() => {
    setPayment(selectedPayment);

    for (let i = 0; i < selectedLand.length; i++) {
      const tokenId = getTokenId(
        parseInt(selectedLand[i].x),
        parseInt(selectedLand[i].y)
      );
      setTokenIds((tokenIds) => [...tokenIds, tokenId]);
    }
  }, []);

  useEffect(() => {
    setActivePaymentButton(!isValid);
    if (isValid) {
      dispatch(controllCheckout());
    }
  }, [isValid]);

  useEffect(() => {
    if (isValid && isChecked) {
      const formUser = user ? user : formData;

      const newCoupon =
        couponApply !== ""
          ? couponApply
          : couponValidate?.data?.coupon
          ? couponValidate?.data?.coupon
          : "";

      const apiData = {
        amount: price,
        coupon: newCoupon.toUpperCase(),
        lands: tokenIds,
        user: {
          country: formUser?.country,
        },
      };

      const data = {
        data: apiData,
      };

      dispatch(verifyCheckout(data));
    }
  }, [isValid, isChecked]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleChangeAddress = (e) => {
    const wallet = e.target.value;

    setAddress(wallet);
  };

  useEffect(() => {
    const isLandAlreadyPurchased = tokenIds.some((tokenId) =>
      checkoutLands?.data?.includes(tokenId.toString())
    );

    if (isLandAlreadyPurchased) {
      console.log("Land già acquistata");
      openCheckoutModalHandle();
    }
  }, [checkoutLands, tokenIds]);

  useEffect(() => {
    if (couponValidate?.data?.coupon) {
      setCouponApply("");
    }
  }, [couponValidate]);

  useEffect(() => {
    const formUser = user ? user : formData;

    const newCoupon =
      couponApply !== ""
        ? couponApply
        : couponValidate?.data?.coupon
        ? couponValidate?.data?.coupon
        : "";

    if (startCall) {
      const apiData = {
        data: {
          stripe_token:
            selectedPayment === "CREDITCARD" && typeCreditCard === "stripe"
              ? paymentInfo?.id
              : "",
          paypal_token:
            selectedPayment === "CREDITCARD" && typeCreditCard === "paypal"
              ? paymentInfo?.id
              : typeCreditCard === "bank-transfer"
              ? new Date().getTime().toString()
              : "",
          payment_type:
            selectedPayment === "CREDITCARD"
              ? typeCreditCard
              : selectedPayment === 2
              ? "usdc"
              : "usdt",
          save_card: false,
          coupon: newCoupon.toUpperCase(),
          referrer: referrer,
          amount: price,
          user: {
            first_name: formUser?.firstname ? formUser?.firstname : "",
            last_name: formUser?.lastname ? formUser?.lastname : "",
            company: formUser?.companyname ? formUser?.companyname : "",
            email: formUser?.email,
            user_type: typeUser,
            address: formUser?.address,
            postcode: formUser?.postalcode,
            city: formUser?.city,
            country: formUser?.country,
            phone: formUser?.phone,
            wallet_address: address,
            vat_number: formUser?.vatnumber ? formUser?.vatnumber : "",
            sdi_code: formUser?.sdi_code ? formUser?.sdi_code : "",
            pec: formUser?.pec ? formUser?.pec : "",
            fiscal_code: formUser?.fiscalcode,
            province: formUser?.province,
          },
          lands: tokenIds,
        },
      };

      const data = {
        token: token,
        data: apiData,
      };

      // attenzione perche se l'utente nn è registrato nn è detto che abbiamo il token

      dispatch(checkout(data));
      console.log("test invio apiData", apiData);
      setStartCall(false);
    }
  }, [startCall]);

  useEffect(() => {
    if (apiResponse !== null) {
      setSuccessPayment(true);
    }
  }, [apiResponse]);

  const {
    mintModalHandle,
    setPopup,
    isPopupMetamask,
    popupHandle,
    popupMetamaskHandle,
    isPopup,
    popupErrorHandle,
  } = useModal();

  const errorNotification = (errorMessage) => {
    const serializedError = serializeError(errorMessage);
    const error = serializedError.data.originalError.reason;
    setError(error.replace("execution reverted: ", ""));

    popupErrorHandle();
  };

  const onchangeTypeUser = (event) => {
    if (event.target.checked) {
      setTypeUser("company");
      setHookTypeUser("company");
    } else {
      setTypeUser("private");
      setHookTypeUser("private");
    }
  };

  const onChangeNewCity = (event) => {
    const selectedCityCode = event.target.value;
    setNewCity(selectedCityCode);
  };

  const onChangeNewProvince = (event) => {
    const selectedProvinceCode = event.target.value;

    const countryName = countryOption.find(
      (option) => option.id.toString() === newCountry.toString()
    );
    onSelectProvince(countryName.country_iso_code, selectedProvinceCode);
    setNewProvince(selectedProvinceCode);
  };

  // const onChangeNewCountry = (event) => {
  //   const selectedCountryCode = event.target.value;
  //   onSelectCountry(selectedCountryCode);
  //   setNewCountry(selectedCountryCode);
  // };

  const onChangeNewCountry = (event) => {
    const selectedCountryId = event.target.value;

    const selectedCountry = countryOption.find(
      (country) => country.id.toString() === selectedCountryId.toString()
    );

    if (selectedCountry) {
      const selectedCountryIsoCode = selectedCountry.country_iso_code;
      onSelectCountry(selectedCountryIsoCode);
      setNewCountry(selectedCountryId);
      setCountryRef(selectedCountryIsoCode);
      setSpecialCountry(selectedCountryIsoCode);
    }
  };

  const handleTypePayment = (type) => {
    setTypeCreditCard(type);
  };

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const accounts = await window?.ethereum?.request({
          method: "eth_accounts",
        });

        console.log("accounts", accounts);
        if (accounts.length === 0) {
          console.log("Please connect to MetaMask.");
        } else {
          setAddress(accounts[0]);
          console.log("We have an account:", accounts[0]);
        }
      } catch (err) {
        console.error("Error fetching accounts:", err);
      }
    };

    // Chiamata alla funzione di fetch quando il componente è montaot
    fetchAccounts();
  }, []);

  if (window.ethereum) {
    window.ethereum.on("accountsChanged", () => {
      console.log("accountsChanged");

      const getWalletAddress = async () => {
        try {
          await AccountsMetamask();
          setAddress(await AccountsMetamask());
        } catch (err) {
          console.error("Error fetching accounts:", err);
        }
      };

      getWalletAddress();
    });
  }

  useEffect(() => {
    if (userAddress) {
      setAddress(userAddress);
    }
  }, [userAddress]);

  const onSubmit = async (data) => {
    console.log("data dentro onsubmit", data);
    setUser(data);

    if (selectedPayment && (selectedPayment === 2 || selectedPayment === 3)) {
      onChainChange(network, setNetwork, setNetworkModalVisibility);

      const fetchAccounts = async () => {
        try {
          const accounts = await window.ethereum.request({
            method: "eth_accounts",
          });

          console.log("accounts", accounts);
          if (accounts.length === 0) {
            setConnected(false);

            console.log("Please connect to MetaMask.");
            toast.custom((t) => (
              <div
                className={`${
                  t.visible ? "animate-enter" : "animate-leave"
                } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
              >
                <div className="flex-1 w-0 py-2 px-3">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 pt-0.5">
                      <img
                        className="h-10 w-10 rounded-full"
                        src={metamask_logo}
                        alt="metamask_logo"
                      />
                    </div>
                    <div className="flex-1">
                      <p className="text-sm font-black text-gray-900 mt-2">
                        Please connect your wallet!
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex">
                  <button
                    onClick={() => toast.dismiss(t.id)}
                    className="w-full border-transparent rounded-none rounded-r-lg py-2 px-3 flex items-center justify-center text-rose-700 hover:text-rose-600 focus:outline-none"
                  >
                    <XCircle />
                  </button>
                </div>
              </div>
            ));
          } else {
            setConnected(true);
            console.log("We have an account:", accounts[0]);
          }
        } catch (err) {
          console.error("Error fetching accounts:", err);
        }
      };

      // Chiamata alla funzione di fetch quando il componente è montato
      fetchAccounts();

      try {
        await handleMint(selectedPayment);
      } catch (e) {
        console.log("ERROR: ", e);
      }
    }

    // if (selectedPayment && selectedPayment === "CREDITCARD") {
    //   setIsStripe(true);
    // }

    if (typeCreditCard === "paypal") {
      setIsPaypal(true);
      setActiveForm(false);
    }
    if (typeCreditCard === "stripe") {
      setIsStripe(true);
      setActiveForm(false);
    }
    if (typeCreditCard === "applepay") {
      setActiveForm(false);
    }
  };

  const handleFreePayment = () => {
    setTypeCreditCard("bank-transfer");
    setStartCall(true);
  };

  useEffect(() => {
    if (useractual?.profile?.data?.country?.data?.code) {
      onSelectCountry(useractual?.profile?.data?.country?.data?.code);
    }
  }, [useractual]);

  const handleMint = async (paymentToken) => {
    console.log("onSubmit - mint");
    console.log("paymentToken - mint", paymentToken);
    console.log("tokenIds - mint", tokenIds);
    if (!isAccountConnected()) {
      console.log("wallet no connected");
      console.log(isPopupMetamask, "isPopupMetamask");

      // popupMetamaskHandle();
    } else if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(
        window.ethereum,
        "any"
      );
      const signer = provider.getSigner();

      const USDCContractInstance = new ethers.Contract(
        USDC_REGISTRY,
        ERC20_ABI,
        signer
      );
      const USDTContractInstance = new ethers.Contract(
        USDT_REGISTRY,
        ERC20_ABI,
        signer
      );
      const contractCandyMachine = new ethers.Contract(
        CANDY_MACHINE,
        CandyMachine_ABI,
        signer
      );

      if (!isWalletConnected()) {
        popupMetamaskHandle();
        console.log("paymentToken - mint", paymentToken);
        console.log("USDC_TOKEN_INDEX - mint", USDC_TOKEN_INDEX);
        console.log("USDT_TOKEN_INDEX - mint", USDT_TOKEN_INDEX);
      } else {
        try {
          if (
            paymentToken === USDC_TOKEN_INDEX ||
            paymentToken === USDT_TOKEN_INDEX
          ) {
            console.log("paymentToken - mint", paymentToken);
            console.log("USDC_TOKEN_INDEX - mint", USDC_TOKEN_INDEX);
            console.log("USDT_TOKEN_INDEX - mint", USDT_TOKEN_INDEX);

            let allowanceTx3;

            if (paymentToken === USDT_TOKEN_INDEX) {
              allowanceTx3 = await USDTContractInstance.allowance(
                await signer.getAddress(),
                contractCandyMachine.address
              );
              console.log("allowanceTx3: ", allowanceTx3);
            } else if (paymentToken === USDC_TOKEN_INDEX) {
              allowanceTx3 = await USDCContractInstance.allowance(
                await signer.getAddress(),
                contractCandyMachine.address
              );
              console.log("allowanceTx3: ", allowanceTx3);

              console.log(
                "USDT_TOKEN_ALLOWANCE:",
                (
                  ethers.utils.parseEther(PRICE.toString()) *
                  selectedLand.length
                ).toLocaleString("fullwide", { useGrouping: false })
              );
            }

            if (
              allowanceTx3 >=
              (
                ethers.utils.parseEther(PRICE.toString()) * selectedLand.length
              ).toString()
            ) {
              const getGasLimit = async () => {
                let gasLimit =
                  await contractCandyMachine.estimateGas.reclaimMultipleLand(
                    paymentToken,
                    tokenIds
                  );

                let newGasLimit =
                  gasLimit.toNumber() + selectedLand.length * SURPLUS;
                console.log("newGasLimit: ", newGasLimit);

                if (newGasLimit < MIN_GAS_LIMIT) {
                  return MIN_GAS_LIMIT;
                } else if (newGasLimit > MAX_GAS_LIMIT) {
                  return MAX_GAS_LIMIT;
                } else {
                  return newGasLimit;
                }
              };

              console.log("ReclaimMultipleLand", paymentToken);

              const reclaimMultipleLand =
                await contractCandyMachine.reclaimMultipleLand(
                  paymentToken,
                  tokenIds,
                  {
                    gasLimit: await getGasLimit(),
                  }
                );

              if (reclaimMultipleLand.confirmations === 0) {
                setPopup(true);
                console.log("Pending reclaimMultipleLand...");
              }

              const ReclaimTx = await reclaimMultipleLand.wait();

              setLogs(await reclaimMultipleLand.wait());

              console.log("ReclaimTx ", ReclaimTx);

              if (logs.confirmations !== 0) {
                setPopup(false);
                setSuccessPayment(true);
                setStartCall(true);
                mintModalHandle();
                console.log(`Reclaimed ${tokenIds.length} lands`);
              }
            } else {
              let increaseAllowance, increaseAllowanceTx;

              if (paymentToken === USDT_TOKEN_INDEX) {
                increaseAllowance =
                  await USDTContractInstance.increaseAllowance(
                    contractCandyMachine.address,
                    (
                      ethers.utils.parseEther(PRICE.toString()) *
                      selectedLand.length.toString()
                    ).toLocaleString("fullwide", { useGrouping: false })
                  );

                if (increaseAllowance.confirmations === 0) {
                  console.log("Pending increaseAllowance...");
                  setPopup(true);
                }

                console.log(increaseAllowance);

                increaseAllowanceTx = await increaseAllowance.wait();
              } else if (paymentToken === USDC_TOKEN_INDEX) {
                increaseAllowance =
                  await USDCContractInstance.increaseAllowance(
                    contractCandyMachine.address,
                    (
                      ethers.utils.parseEther(PRICE.toString()) *
                      selectedLand.length.toString()
                    ).toLocaleString("fullwide", { useGrouping: false })
                  );

                if (increaseAllowance.confirmations === 0) {
                  console.log("Pending increaseAllowance...");
                  setPopup(true);
                }

                console.log(increaseAllowance);

                increaseAllowanceTx = await increaseAllowance.wait();
              }

              if (increaseAllowanceTx) {
                setPopup(false);
              }

              // console.log("increaseAllowance done");

              const getGasLimit = async () => {
                let gasLimit =
                  await contractCandyMachine.estimateGas.reclaimMultipleLand(
                    paymentToken,
                    tokenIds
                  );

                let newGasLimit =
                  gasLimit.toNumber() + tokenIds.length * SURPLUS;
                console.log("newGasLimit: ", newGasLimit);

                if (newGasLimit < MIN_GAS_LIMIT) {
                  return MIN_GAS_LIMIT;
                } else if (newGasLimit > MAX_GAS_LIMIT) {
                  return MAX_GAS_LIMIT;
                } else {
                  return newGasLimit;
                }
              };

              const reclaimMultipleLand =
                await contractCandyMachine.reclaimMultipleLand(
                  paymentToken,
                  tokenIds,
                  {
                    gasLimit: await getGasLimit(),
                  }
                );

              if (reclaimMultipleLand.confirmations === 0) {
                console.log("Pending reclaimMultipleLand...");
                setPopup(true);
              }

              const ReclaimTx = await reclaimMultipleLand.wait();

              console.log(ReclaimTx);

              setLogs(await reclaimMultipleLand.wait());

              if (logs.confirmations !== 0) {
                setPopup(false);
                setSuccessPayment(true);
                setStartCall(true);
                mintModalHandle();
                console.log(`Reclaimed ${tokenIds.length} lands`);
              }
            }
          }
        } catch (err) {
          console.log("ERROR: ", err);
          setPopup(false);
          errorNotification(err);
        }
      }
    }
  };

  useEffect(() => {
    const errorObject = {};

    Object.keys(errors).forEach((key) => {
      errorObject[key] = errors[key]?.message;
    });

    // Puoi fare qualcosa con l'oggetto degli errori se necessario
    console.log("Error Object:", errorObject);

    if (Object.keys(errors).length > 0) {
      setIsChecked(false);
    }
  }, [errors]);

  const handleApplyCouponWallet = (e) => {
    console.log("formData", formData);
    e.preventDefault();
    const data = {
      data: {
        ownerAddress: address,
        size: selectedLand?.length > 0 ? selectedLand?.length : 0,
      },
    };

    dispatch(couponCheckWallet(data));
  };

  useEffect(() => {
    if (verifyImportBe?.data?.totalPrice === price) {
      setControllPriceBE(1);
      if (price === 0) {
        setFreePayment(true);
      }
    }
    if (
      verifyImportBe &&
      verifyImportBe.data &&
      verifyImportBe?.data?.totalPrice !== price
    ) {
      console.log("importi diversi");
      setControllPriceBE(2);
    }
  }, [verifyImportBe]);

  const isValidAddress =
    (address && ethers.utils.isAddress(address)) || address === "";

  useEffect(() => {
    if (!isValidAddress && address !== "") {
      toast.error("Invalid metamask address.");
    }
  }, [isValidAddress]);

  console.log("!isChecked && !isValidAddress", !isChecked && !isValidAddress);

  return (
    <>
      {checkoutModalVisibility && <CheckoutModal />}
      {activeForm && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <div className="flex items-center space-x-2 justify-center mb-4">
              <input
                type="checkbox"
                id="company"
                name="company"
                onChange={onchangeTypeUser}
                className="w-5"
                disabled={isChecked}
              />
              <Label htmlFor="company" className="label-Input-form">
                Is a company
              </Label>
            </div>
          </div>

          <div className="input-container">
            <div>
              <div style={{ display: "none" }}>
                <Label className="label-Input-form">Optional Sales</Label>
                <Input value={referrer} {...register("referrer")} />
              </div>

              {typeUser === "private" ? (
                <>
                  <div className="container-input">
                    <Label className="label-Input-form">First name *</Label>
                    <Input
                      disabled={isChecked}
                      {...register("firstname")}
                      className={`${errors.firstname ? "error-Input" : null}`}
                    />
                    {errors.firstname && (
                      <span className="error-Span-Input">
                        {errors.firstname.message}
                      </span>
                    )}
                  </div>
                </>
              ) : (
                <div className="container-input">
                  <Label className="label-Input-form">Company name *</Label>
                  <Input
                    {...register("companyname")}
                    className={`${errors.companyname ? "error-Input" : null}`}
                    disabled={isChecked}
                  />
                  {errors.companyname && (
                    <span className="error-Span-Input">
                      {errors.companyname.message}
                    </span>
                  )}
                </div>
              )}

              <div className="container-input">
                <Label className="label-Input-form">Email *</Label>
                <Input
                  {...register("email")}
                  className={`${errors.email ? "error-Input" : null}`}
                  disabled={isChecked}
                />
                {errors.email && (
                  <span className="error-Span-Input">
                    {errors.email.message}
                  </span>
                )}
              </div>

              <div className="container-input">
                <Label className="label-Input-form">Country *</Label>
                <select
                  disabled={isChecked}
                  {...register("country")}
                  value={newCountry}
                  className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                  onChange={onChangeNewCountry}
                >
                  <option value="">Select Country</option>
                  {countryOption.length > 0
                    ? /* eslint-disable */
                      countryOption.map((country) =>
                        country.country_name !== "" ? (
                          <option key={country.id} value={country.id}>
                            {country.country_name}
                          </option>
                        ) : null
                      )
                    : ""}
                </select>
                {errors.country && (
                  <span className="error-Span-Input">
                    {errors.country.message}
                  </span>
                )}
              </div>

              <div className="container-input">
                <Label className="label-Input-form">Province *</Label>
                <select
                  disabled={isChecked}
                  {...register("province")}
                  value={newProvince}
                  className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                  onChange={onChangeNewProvince}
                >
                  <option value="">Select Province</option>
                  {provinceOption.length > 0
                    ? /* eslint-disable */
                      provinceOption.map((province) =>
                        province.subdivision_name !== "" ? (
                          <option
                            key={province.subdivision_iso_code}
                            value={province.subdivision_iso_code}
                          >
                            {province.subdivision_name}
                          </option>
                        ) : null
                      )
                    : ""}
                </select>
                {errors.province && (
                  <span className="error-Span-Input">
                    {errors.province.message}
                  </span>
                )}
              </div>

              <div className="container-input">
                <Label className="label-Input-form">City *</Label>
                <select
                  disabled={isChecked}
                  {...register("city")}
                  value={newCity}
                  className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                  onChange={onChangeNewCity}
                >
                  <option value="">Select City</option>
                  {cityOption.length > 0
                    ? /* eslint-disable */
                      cityOption.map((city) =>
                        city.name !== "" ? (
                          <option key={city.id} value={city.id}>
                            {city.name}
                          </option>
                        ) : null
                      )
                    : ""}
                </select>
                {errors.city && (
                  <span className="error-Span-Input">
                    {errors.city.message}
                  </span>
                )}
              </div>

              {specialCountry === "IT" && typeUser === "company" && (
                <div className="container-input">
                  <Label className="label-Input-form">PEC address *</Label>
                  <Input
                    disabled={isChecked}
                    {...register("pec")}
                    className={`${errors.pec ? "error-Input" : null}`}
                  />
                  {errors.pec && (
                    <span className="error-Span-Input">
                      {errors.pec.message}
                    </span>
                  )}
                </div>
              )}
            </div>

            <div>
              {typeUser === "private" && (
                <>
                  <div className="container-input">
                    <Label className="label-Input-form">Last name *</Label>
                    <Input
                      disabled={isChecked}
                      {...register("lastname")}
                      className={`${errors.lastname ? "error-Input" : null}`}
                    />
                    {errors.lastname && (
                      <span className="error-Span-Input">
                        {errors.lastname.message}
                      </span>
                    )}
                  </div>
                </>
              )}

              {typeUser === "company" ? (
                <div className="container-input">
                  <Label className="label-Input-form">Vat number *</Label>
                  <Input
                    disabled={isChecked}
                    {...register("vatnumber")}
                    className={`${errors.vatnumber ? "error-Input" : null}`}
                  />
                  {errors.vatnumber && (
                    <span className="error-Span-Input">
                      {errors.vatnumber.message}
                    </span>
                  )}
                </div>
              ) : null}

              <div className="container-input">
                <Label className="label-Input-form">Fiscal Code *</Label>
                <Input
                  disabled={isChecked}
                  {...register("fiscalcode")}
                  className={`${errors.fiscalcode ? "error-Input" : null}`}
                />
                {errors.fiscalcode && (
                  <span className="error-Span-Input">
                    {errors.fiscalcode.message}
                  </span>
                )}
              </div>

              <div className="container-input">
                <Label className="label-Input-form">Address *</Label>
                <Input
                  disabled={isChecked}
                  {...register("address")}
                  className={`${errors.address ? "error-Input" : null}`}
                />
                {errors.address && (
                  <span className="error-Span-Input">
                    {errors.address.message}
                  </span>
                )}
              </div>

              <div className="container-input">
                <Label className="label-Input-form">Postal Code *</Label>
                <Input
                  disabled={isChecked}
                  {...register("postalcode")}
                  className={`${errors.postalcode ? "error-Input" : null}`}
                />
                {errors.postalcode && (
                  <span className="error-Span-Input">
                    {errors.postalcode.message}
                  </span>
                )}
              </div>

              <div className="container-input">
                <Label className="label-Input-form">Phone</Label>
                <Input
                  disabled={isChecked}
                  {...register("phone")}
                  className={`${errors.phone ? "error-Input" : null}`}
                />
                {errors.phone && (
                  <span className="error-Span-Input">
                    {errors.phone.message}
                  </span>
                )}
              </div>

              {specialCountry === "IT" && typeUser === "company" && (
                <div className="container-input">
                  <Label className="label-Input-form">SDI code *</Label>
                  <Input
                    disabled={isChecked}
                    {...register("sdi_code")}
                    className={`${errors.sdi_code ? "error-Input" : null}`}
                  />
                  {errors.sdi_code && (
                    <span className="error-Span-Input">
                      {errors.sdi_code.message}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>

          {selectedPayment === "CREDITCARD" ? (
            <div className="container-input mb-5">
              <Label className="label-Input-form">Metamask Address</Label>
              <div className="flex">
                <Input
                  disabled={isChecked}
                  {...register("metamask")}
                  value={address ? address : ""}
                  placeholder="0x0000"
                  onChange={handleChangeAddress}
                  className={`${errors.metamaskAddress ? "error-Input" : null}`}
                />
                <Button
                  className="mx-4"
                  disabled={couponValidate?.data?.success || isChecked}
                  onClick={handleApplyCouponWallet}
                >
                  Check discount
                </Button>
              </div>
              <p className="text-black text-[10px] text-start">
                Enter your address here if you want to receive your lands on
                your wallet now. <br />
                If you are a pre-sale landowner, check if your wallet is
                eligible for a 50% discount.
              </p>
              {errors.metamaskAddress && (
                <span className="error-Span-Input">
                  {errors.metamaskAddress.message}
                </span>
              )}
              {couponValidate && couponValidate?.data?.success === false && (
                <div>Your wallet has not available discounts.</div>
              )}
            </div>
          ) : (
            <div className="container-input mb-5">
              <Label className="label-Input-form">Metamask Address</Label>
              <Input
                {...register("metamask")}
                value={address}
                onChange={handleChangeAddress}
                placeholder="0x0000"
                className={`${errors.metamaskAddress ? "error-Input" : null}`}
                disabled
              />
              {errors.metamaskAddress && (
                <span className="error-Span-Input">
                  {errors.metamaskAddress.message}
                </span>
              )}
            </div>
          )}

          <Separator />

          <Price
            activeForm={activeForm}
            selectedPayment={selectedPayment}
            disabled={isChecked}
            setCouponApply={setCouponApply}
          />

          <Separator />

          <div className="container-input mb-5 mt-5">
            <div className="flex">
              {selectedPayment === "CREDITCARD" ? (
                <Checkbox
                  onCheckedChange={() => handleCheckboxChange()}
                  checked={isChecked}
                  type="submit"
                />
              ) : (
                <Checkbox
                  onCheckedChange={() => handleCheckboxChange()}
                  checked={isChecked}
                />
              )}

              <div className="grid gap-1.5 leading-none mx-2 ">
                <label
                  htmlFor="terms1"
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                >
                  Accept terms and conditions
                </label>
                <p className="text-sm text-muted-foreground text-start">
                  By checking this box, you acknowledge that you have read,
                  understood, and agree to accept our Terms and Conditions
                  available
                  <a
                    className="text-sm text-muted-foreground text-start"
                    href="https://coderblock.com/toc-metaverse"
                    target="_blank"
                  >
                    {" "}
                    here
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>

          <Separator />

          {selectedPayment &&
          (selectedPayment === 2 || selectedPayment === 3) ? (
            <div className="p-3">
              <Button
                disabled={!isChecked}
                className="mx-auto font-general mt-3"
                type="submit"
              >
                Pay now
              </Button>
            </div>
          ) : null}

          {freePayment && (
            <div className="p-3">
              <Button
                style={{
                  height: "55px",
                  transition: "all 0.2s ease-in-out 0s",
                  position: "relative",
                  display: "inline-block",
                }}
                disabled={!isChecked || (isChecked && !isValidAddress)}
                className="mx-auto w-[280px] md:w-[150px] font-general bg-blue-600 text-white"
                type="submit"
                onClick={() => handleFreePayment()}
              >
                Next
              </Button>
            </div>
          )}

          {controllPriceBE === 2 && <div>❌ Error Generic</div>}

          {selectedPayment &&
          selectedPayment === "CREDITCARD" &&
          !freePayment &&
          controllPriceBE !== 2 ? (
            <>
              <div className="flex flex-col gap-4 md:flex-row justify-center items-center  mt-10">
                {/* Stripe Button */}
                <div className="w-full">
                  <Button
                    style={{
                      height: "55px",
                      transition: "all 0.2s ease-in-out 0s",
                      position: "relative",
                      display: "inline-block",
                    }}
                    disabled={!isChecked || (isChecked && !isValidAddress)}
                    className="mx-auto w-full font-general bg-blue-600 text-white"
                    type="submit"
                    onClick={() => handleTypePayment("stripe")}
                    // disabled={activePaymentButton}
                  >
                    <span className="font-bold text-lg">Stripe</span>
                  </Button>
                </div>
              </div>

              {/* Apple Pay Button */}

              {/* <div className="mt-3">
                {isValid && isChecked && controllPriceBE === 1 ? (
                  <>
                    <ApplePay
                      setSuccessPayment={setSuccessPayment}
                      price={price}
                      setPaymentInfo={setPaymentInfo}
                      setStartCall={setStartCall}
                      activePaymentButton={activePaymentButton}
                      setTypeCreditCard={setTypeCreditCard}
                    />
                  </>
                ) : controllPriceBE === 2 ? null : (
                  <Button
                    disabled={!isChecked}
                    className="w-full h-[55px] font-general bg-[#020200] hover:brightness-95 hover:.bg-[#020200]"
                    type="submit"
                    onClick={() => handleTypePayment("applepay")}
                  >
                    <span className="font-bold text-lg">Apple Pay</span>
                  </Button>
                )}
              </div> */}

              {/* PayPal Button */}

              <div className="mt-3">
                {isValid &&
                isChecked &&
                controllPriceBE === 1 &&
                isValidAddress ? (
                  <>
                    <PayPal
                      setSuccessPayment={setSuccessPayment}
                      price={price}
                      setPaymentInfo={setPaymentInfo}
                      setStartCall={setStartCall}
                      activePaymentButton={activePaymentButton}
                      selectedLand={selectedLand}
                      setTypeCreditCard={setTypeCreditCard}
                    />
                  </>
                ) : controllPriceBE === 2 ? null : (
                  <Button
                    disabled={!isChecked || (isChecked && !isValidAddress)}
                    className="mx-auto w-full h-[55px] font-general bg-[#FFC43C] hover:brightness-95 hover:bg-[#FFC43C]"
                    type="submit"
                    onClick={() => handleTypePayment("paypal")}
                  >
                    <img src={LogoPaypal} width={75} height={24} />
                  </Button>
                )}
              </div>
            </>
          ) : null}
        </form>
      )}
      <Toaster position="bottom-center" />
      {networkModalVisibility &&
      selectedPayment &&
      (selectedPayment === 2 || selectedPayment === 3) ? (
        <NetworkModal />
      ) : null}
      {selectedPayment &&
      selectedPayment === "CREDITCARD" &&
      isStripe &&
      controllPriceBE === 1 ? (
        <Stripe
          setSuccessPayment={setSuccessPayment}
          price={price}
          setPaymentInfo={setPaymentInfo}
          setStartCall={setStartCall}
          setTypeCreditCard={setTypeCreditCard}
          formData={formData}
          typeUser={typeUser}
          cityOption={cityOption}
          countryOption={countryOption}
        />
      ) : null}
    </>
  );
};

export default FormCheckout;
